/* eslint-disable react-hooks/rules-of-hooks */
import { MxWidgetUrl, MxWidgetType } from "@modules/mx/types";
import request from "@common/request";
import { useQuery } from "react-query";
import useStore from "@modules/mx/state";

const useWidget = (
  widgetType: MxWidgetType,
  queryOptions = {},
  isMobileWebView = false
) => {
  return useQuery(
    ["widget", widgetType],
    () =>
      request<{ url: MxWidgetUrl }>(
        "GET",
        `/api/mx/widget/${widgetType}?isMobileWebView=${isMobileWebView}`
      ),
    {
      refetchOnWindowFocus: false,
      // caching doesn't work because MX expires the link when it's unmounted
      cacheTime: 0,
      ...queryOptions,
    }
  );
};

const useMxZeroState = () => {
  const { isMxZeroState, setIsMxZeroState } = useStore();

  const { isLoading: isCheckingZeroState } = useQuery(
    "mxZeroStateCheck",
    () => request<{ hasMembers: boolean }>("GET", `/api/mx/connected`),
    {
      enabled: isMxZeroState,
      onSuccess: ({ hasMembers }) => {
        if (hasMembers) {
          setIsMxZeroState(false);
        }
      },
    }
  );

  return {
    isCheckingZeroState,
    isMxZeroState,
    setIsMxZeroState,
  };
};

export { useWidget, useMxZeroState };
